export interface CustomerTicket {
  id: string;
  customerId: string;
  customerName: string; // Denormalizált
  organizationId: string;
  
  // Ticket típusa
  type: 'document_request' | 'question' | 'task_request' | 'complaint' | 'other';
  
  // Alapadatok
  title: string;
  description: string;
  priority: 'low' | 'medium' | 'high' | 'urgent';
  status: 'submitted' | 'in_progress' | 'waiting_customer' | 'completed' | 'cancelled';
  
  // Ügyfél látja
  customerNotes?: string;
  
  // Csak belső (staff)
  internalNotes?: string;
  assignedTo?: string;
  assignedToName?: string;
  
  // Válaszok, kommunikáció
  responses?: TicketResponse[];
  
  // Mellékletek
  attachments?: TicketAttachment[];
  
  // Határidők
  dueDate?: Date;
  estimatedCompletionDate?: Date;
  
  // Időbélyegek
  createdAt: Date;
  createdBy: string;
  updatedAt: Date;
  completedAt?: Date;
  cancelledAt?: Date;
  
  // Opcionális: kapcsolat belső projekttel
  linkedProjectId?: string;
}

export interface TicketResponse {
  id: string;
  message: string;
  createdBy: string;
  createdByName: string;
  isStaff: boolean; // true = munkatárs, false = ügyfél
  createdAt: Date;
  attachments?: TicketAttachment[];
  isInternal?: boolean; // Csak munkatársak látják
}

export interface TicketAttachment {
  id: string;
  name: string;
  url: string;
  size: number;
  type: string;
  uploadedBy: string;
  uploadedByName: string;
  uploadedAt: Date;
  documentId?: string; // Link a dokumentumtárhoz
  storagePath?: string; // Firebase Storage path (törléshez)
}

export const TICKET_TYPES = {
  document_request: 'Dokumentum kérés',
  question: 'Kérdés',
  task_request: 'Feladat kérés',
  complaint: 'Panasz',
  other: 'Egyéb'
} as const;

export const TICKET_PRIORITIES = {
  low: 'Alacsony',
  medium: 'Közepes',
  high: 'Magas',
  urgent: 'Sürgős'
} as const;

export const TICKET_STATUSES = {
  submitted: 'Beküldve',
  in_progress: 'Folyamatban',
  waiting_customer: 'Ügyfélre vár',
  completed: 'Befejezve',
  cancelled: 'Törölve'
} as const;
